<template>
  <custom-dialog width="530px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form :model="form" :inline="true" :rules="rules" ref="form" label-width="150px">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('crm_contract_confirmSend_dialog.qsjzrq')">
              <custom-date-picker
                v-model="form.signingDate"
                :placeholder="$t('crm_contract_confirmSend_dialog.xuan_ze_ri_qi')"
                type="datetime"
                value-format="YYYY-MM-DD HH:mm:ss"
                :picker-options="beforeToday"
              ></custom-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('crm_contract_confirmSend_dialog.qsjdb')" prop="partyAName">
              {{contractInfo.partyAName}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('crm_contract_confirmSend_dialog.qian_shu_yi_fang')" prop="siteAddress">
               {{contractInfo.partnerName}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{$t('Common.com_cancel')}}</el-button>
      <el-button size="small" type="primary" @click="confirm">{{$t('Common.com_confirm')}}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import moment from 'moment';
import apis from '@/utils/apis';

export default {
  inject: ['getContractInfo'],
  computed: {
    contractInfo() {
      return this.getContractInfo();
    },
  },
  watch: {
    contractInfo: function () {
      this.setContractInfo();
    },
  },

  data() {
    return {
      visible: true,
      selectRow: {},
      form: {

        signingDate: ''
      },

    };
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      if (this.model.type === 'edit') {
        this.selectRow = this.data.row;
      }
    },
    setContractInfo: function () {
      this.signingDate = moment(this.contractInfo.signingDate).add(7, 'd');
    },
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          // return;
        }
        this.sendEmail();
      });
    },
    // 保存新增
    sendEmail: function () {
      this.$postJSON(apis.SiteAdd, this.form).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },

  },
};
</script>

<style lang="scss">
</style>
